import React from 'react';

import * as Images from 'pos/Images';
import * as UI from 'core/ui';
import { VStack, HStack, Box, Separator, Text, Table } from '@chakra-ui/react';
import { CustomerDetailsDTO, Res } from 'core/api';
import { CountryNames } from 'core/infrastructure';
import { CardPanel, SvgIcon } from 'core/ui-next';
import { isPhone } from 'pos/ui/ThemeManager';


export function administrativePanel(customer: CustomerDetailsDTO): React.ReactNode {
	return (
		<CardPanel w={isPhone() ? '100%' : '50%'} h={'62.5'} minH={'62.5'} maxH={'62.5'} background={'card'} shadow={'md'}>
			<VStack width={'full'} gap={'6'}>
				<HStack width={'full'} gap={'2'} alignItems={'self-start'}>
					<SvgIcon src={Images.User} width={'4.5'} height={'4.5'} />
					<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_ADMINISTRATIVE_DATA_LBL()}</Text>
				</HStack>
				<HStack width={'full'} gap={'4'} h={'45'} alignItems={'flex-start'} overflowY={'auto'}>
					<VStack gap={'4'} w={'50%'}>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_FISCAL_NAME_LBL()}</Text>
							</Box>
							{customer.FiscalName !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.FiscalName}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_BUSINESS_NAME_LBL()}</Text>
							</Box>
							{customer.BusinessName !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.BusinessName}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_COUNTRY_LBL()}</Text>
							</Box>
							{customer.CountryCode !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{CountryNames.getName(customer.CountryCode)}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
					</VStack>
					<Separator orientation={'vertical'} height={'full'} color={'neutral.100'} h={'45'} />
					<VStack gap={'4'} w={'50%'}>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_CIF_LBL()}</Text>
							</Box>
							{customer.Cif !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Cif}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_ACCOUNT_LBL()}</Text>
							</Box>
							{customer.AccountCode !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.AccountCode}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_TYPE_LBL()}</Text>
							</Box>
							{customer.Type.Id !== 0
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Type.Name}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
					</VStack>
				</HStack>
			</VStack>
		</CardPanel>);
}

export function contactPanel(customer: CustomerDetailsDTO): React.ReactNode {
	return (
		<CardPanel w={isPhone() ? '100%' : '50%'} h={'62.5'} minH={'62.5'} maxH={'62.5'} background={'card'} shadow={'md'}>
			<VStack width={'full'} gap={'6'}>
				<HStack width={'full'} gap={'4'} alignItems={'flex-start'}>
					<HStack width={'full'} gap={'2'}>
						<SvgIcon src={Images.Phone} width={'4.5'} height={'4.5'} />
						<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_CONTACT_LBL()}</Text>
					</HStack>
				</HStack>
				<HStack width={'full'} gap={'4'} h={'45'} alignItems={'flex-start'} overflowY={'auto'}>
					<VStack width={'50%'} gap={'4'}>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_CONTACT_PERSON_LBL()}</Text>
							</Box>
							{customer.ContactPerson !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.ContactPerson}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_TELEPHONE_LBL()}</Text>
							</Box>
							{customer.Telephone !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Telephone}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_COUNTRY_LBL()}</Text>
							</Box>
							{customer.CountryCode !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{CountryNames.getName(customer.CountryCode)}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
					</VStack>
					<Separator orientation={'vertical'} height={'full'} color={'neutral.100'} h={'45'} />
					<VStack width={'50%'} gap={'4'}>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_EMAIL_LBL()}</Text>
							</Box>
							{customer.Email !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Email}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_RECIEVE_ADVERTISING_LBL()}</Text>
							</Box>
							{customer.SendMailing !== null && customer.SendMailing !== undefined
								? <Box minH={'5'} display={'flex'} alignItems={'center'} gap={'2'}>
									<Text fontSize={'sm'}>{customer.SendMailing ? Res.Web.SHOW_CUSTOMER_RECIEVE_ADVERTISING_YES_LBL() : Res.Web.SHOW_CUSTOMER_RECIEVE_ADVERTISING_NO_LBL()}</Text>
								</Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
					</VStack>
				</HStack>
			</VStack>
		</CardPanel>);
}

export function locationPanel(customer: CustomerDetailsDTO): React.ReactNode {
	return (
		<CardPanel w={isPhone() ? '100%' : '50%'} h={'52'} minH={'52'} maxH={'52'} background={'card'} shadow={'md'}>
			<VStack width={'full'} gap={'6'}>
				<HStack width={'full'} gap={'2'} alignItems={'self-start'}>
					<SvgIcon src={Images.Location} width={'4.5'} height={'4.5'} />
					<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_LOCATION_LBL()}</Text>
				</HStack>
				<HStack width={'full'} gap={'4'} h={'29.5'} alignItems={'flex-start'} overflowY={'auto'}>
					<VStack gap={'4'} w={'50%'}>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_ADDRESS_LBL()}</Text>
							</Box>
							{customer.Address.Street !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Address.Street}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_ZIPCODE_LBL()}</Text>
							</Box>
							{customer.Address.ZipCode !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Address.ZipCode}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
					</VStack>
					<Separator orientation={'vertical'} height={'full'} color={'neutral.100'} h={'29.5'} />
					<VStack gap={'4'} w={'50%'}>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_CITY_LBL()}</Text>
							</Box>
							{customer.Address.City !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Address.City}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
						<Box width={'full'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_REGION_LBL()}</Text>
							</Box>
							{customer.Address.Region !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.Address.Region}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</Box>
					</VStack>
				</HStack>
			</VStack>
		</CardPanel>);
}

export function commercialTermsPanel(customer: CustomerDetailsDTO): React.ReactNode {
	return (
		<CardPanel w={isPhone() ? '100%' : '50%'} h={'52'} minH={'52'} maxH={'52'} background={'card'} shadow={'md'}>
			<VStack width={'full'} gap={'6'}>
				<HStack width={'full'} gap={'2'} alignItems={'self-start'}>
					<SvgIcon src={Images.Tag} width={'4.5'} height={'4.5'} />
					<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_COMMERCIAL_TERMS_LBL()}</Text>
				</HStack>
				<HStack width={'full'} gap={'4'} h={'29.5'} alignItems={'flex-start'} overflowY={'auto'}>
					<VStack gap={'4'} w={'50%'}>
						<VStack width={'full'} alignItems={'flex-start'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_CARD_NUMBER_LBL()}</Text>
							</Box>
							{customer.CardNumber !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.CardNumber}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</VStack>
						<VStack width={'full'} alignItems={'flex-start'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_PRICE_LIST_LBL()}</Text>
							</Box>
							{customer.PriceList !== ''
								? <Box minH={'5'}><Text fontSize={'sm'}>{customer.PriceList}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</VStack>
					</VStack>
					<Separator orientation={'vertical'} height={'full'} color={'neutral.100'} h={'29.5'} />
					<VStack gap={'4'} w={'50%'}>
						<VStack width={'full'} alignItems={'flex-start'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_DISCOUNT_TITLE_LBL()}</Text>
							</Box>
							{customer.DiscountRate > 0
								? <Box minH={'5'}><Text fontSize={'sm'}>{UI.Format.asPercentage(customer.DiscountRate * 100)}</Text></Box>
								: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
							}
						</VStack>
						<VStack width={'full'} alignItems={'flex-start'}>
							<Box minH={'5'}>
								<Text fontSize={'sm'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_APPLY_SURCHARGE_LBL()}</Text>
							</Box>
							<Box minH={'5'}>
								{customer.ApplySurcharge !== null && customer.ApplySurcharge !== undefined
									? <Box minH={'5'} display={'flex'} alignItems={'center'} gap={'2'}>
										<Text fontSize={'sm'}>{customer.ApplySurcharge ? Res.Web.SHOW_CUSTOMER_APPLY_SURCHARGE_YES_LBL() : Res.Web.SHOW_CUSTOMER_APPLY_SURCHARGE_NO_LBL()}</Text>
									</Box>
									: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
								}
							</Box>
						</VStack>
					</VStack>
				</HStack>
			</VStack>
		</CardPanel>);
}

export function promotionsPanel(customer: CustomerDetailsDTO): React.ReactNode {
	return (
		<CardPanel w={'66%'} h={'61'} minH={'61'} maxH={'61'} background={'card'} shadow={'md'}>
			<VStack width={'full'} gap={'6'}>
				<HStack width={'full'} gap={'2'} alignItems={'self-start'}>
					<SvgIcon src={Images.Offer} width={'4.5'} height={'4.5'} />
					<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_OFFERS_LBL()}</Text>
				</HStack>
				<Box width={'full'} h={'38.5'} overflowY={'auto'}>
					{customer.Offers.length > 0
						? <Table.Root size={'sm'} striped stickyHeader>
							<Table.Header>
								<Table.Row>
									<Table.ColumnHeader>
										<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_ID_LBL()}</Text>
									</Table.ColumnHeader>
									<Table.ColumnHeader >
										<Text fontSize={'sm'} textAlign={'start'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_NAME_LBL()}</Text>
									</Table.ColumnHeader>
									<Table.ColumnHeader>
										<Text fontSize={'sm'} textAlign={'end'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_MAX_APPLICATIONS_LBL()}</Text>
									</Table.ColumnHeader>
									<Table.ColumnHeader>
										<Text fontSize={'sm'} textAlign={'center'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_FROM_LBL()}</Text>
									</Table.ColumnHeader>
									<Table.ColumnHeader>
										<Text fontSize={'sm'} textAlign={'center'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_TO_LBL()}</Text>
									</Table.ColumnHeader>
									<Table.ColumnHeader>
										<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_SCHEDULE_LBL()}</Text>
									</Table.ColumnHeader>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{customer.Offers.map((customerOffer, index) => (
									<Table.Row key={index}>
										<Table.Cell><Text fontSize={'sm'}>{customerOffer.Offer.Id}</Text></Table.Cell>
										<Table.Cell><Text textAlign={'start'} fontSize={'sm'}>{customerOffer.Offer.Name}</Text></Table.Cell>
										<Table.Cell><Text textAlign={'end'} fontSize={'sm'}>{customerOffer.MaxApplicationsPerBusinessDay ?? ''}</Text></Table.Cell>
										<Table.Cell><Text fontSize={'sm'}>{UI.Format.asDate(customerOffer.Offer.From)}</Text></Table.Cell>
										<Table.Cell><Text fontSize={'sm'}>{UI.Format.asDate(customerOffer.Offer.To)}</Text></Table.Cell>
										<Table.Cell><Text fontSize={'sm'}>{customerOffer.Offer.ScheduleDescription}</Text></Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table.Root>
						: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
					}
				</Box>
			</VStack>
		</CardPanel>);
}

export function promotionsPhonePanel(customer: CustomerDetailsDTO): React.ReactNode {
	return (<CardPanel w={'100%'} h={customer.Offers.length > 0 ? '92.5' : 'auto'} minH={customer.Offers.length > 0 ? '92.5' : 'auto'} maxH={'92.5'} background={'card'} shadow={'md'}>
		<VStack width={'full'} gap={'6'} height={'100%'}>
			<HStack width={'full'} gap={'2'} alignItems={'self-start'}>
				<SvgIcon src={Images.Offer} width={'4.5'} height={'4.5'} />
				<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_OFFERS_LBL()}</Text>
			</HStack>
			<Box width={'full'} h={'100%'} overflowY={'auto'}>
				{customer.Offers.length > 0
					? <Table.Root size={'sm'} striped stickyHeader tableLayout={'fixed'} width={'full'} padding={'0'}>
						<Table.Header>
							<Table.Row>
								<Table.ColumnHeader w={'50%'}>
									<Text fontSize={'sm'} textAlign={'start'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_NAME_LBL()}</Text>
								</Table.ColumnHeader>
								<Table.ColumnHeader w={'50%'}>
									<Text fontSize={'sm'} textAlign={'end'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_SCHEDULE_LBL()}</Text>
								</Table.ColumnHeader>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{customer.Offers.map((customerOffer, index) => (
								<Table.Row key={index}>
									<Table.Cell w={'50%'} verticalAlign={'top'}>
										<Box display={'flex'} flexDirection={'column'} gap={'2'}>
											<Box>
												{customerOffer.Offer.Name !== ''
													? <Text textAlign={'start'} fontSize={'sm'}>{customerOffer.Offer.Name}</Text>
													: <></>
												}
											</Box>
											<Box>
												{customerOffer.Offer.Id !== 0
													? <Text textAlign={'start'} fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_ID_LBL() + ' - ' + customerOffer.Offer.Id}</Text>
													: <></>
												}
											</Box>
											<Box>
												{customerOffer.MaxApplicationsPerBusinessDay !== null && customerOffer.MaxApplicationsPerBusinessDay !== undefined
													? <Text textAlign={'start'} fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_MAX_APPLICATIONS_LBL() + ' - ' + customerOffer.MaxApplicationsPerBusinessDay}</Text>
													: <></>
												}
											</Box>
										</Box>
									</Table.Cell>
									<Table.Cell w={'50%'} verticalAlign={'top'}>
										<Box display={'flex'} flexDirection={'column'} gap={'2'}>
											<Box>
												{customerOffer.Offer.ScheduleDescription !== ''
													? <Text textAlign={'end'} fontSize={'sm'}>{customerOffer.Offer.ScheduleDescription}</Text>
													: <></>
												}
											</Box>
											<Box>
												{customerOffer.Offer.From !== null && customerOffer.Offer.From !== undefined
													? <Text textAlign={'end'} fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_FROM_LBL() + ' - ' + UI.Format.asDate(customerOffer.Offer.From)}</Text>
													: <></>
												}
											</Box>
											<Box>
												{customerOffer.Offer.To !== null && customerOffer.Offer.To !== undefined
													? <Text textAlign={'end'} fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_OFFERS_TO_LBL() + ' - ' + UI.Format.asDate(customerOffer.Offer.To)}</Text>
													: <></>
												}
											</Box>
										</Box>
									</Table.Cell>
								</Table.Row>
							))}
						</Table.Body>
					</Table.Root>
					: <Box minH={'9'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
				}
			</Box>
		</VStack>
	</CardPanel>);
}

export function notesPanel(customer: CustomerDetailsDTO): React.ReactNode {
	return (
		<CardPanel w={isPhone() ? '100%' : '34%'} h={customer.Notes !== '' ? '61' : !isPhone() ? '61' : 'auto'} minH={customer.Notes !== '' ? '61' : !isPhone() ? '61' : 'auto'} maxH={'61'} background={'card'} shadow={'md'}>
			<VStack width={'full'} gap={'6'}>
				<HStack width={'full'} gap={'2'} alignItems={'self-start'}>
					<SvgIcon src={Images.Observations} width={'4.5'} height={'4.5'} />
					<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.SHOW_CUSTOMER_NOTES_LBL()}</Text>
				</HStack>
				<Box width={'full'} h={customer.Notes !== '' ? '38.5' : !isPhone() ? '38.5' : 'auto'} overflowY={'auto'}>
					{customer.Notes !== ''
						? <VStack width={'full'} alignItems={'flex-start'} gap={'1'}>
							{customer.Notes.split('\n').map((line, index) => (
								<Box key={index} minH={'5'} width={'full'}>
									<Text fontSize={'sm'}>{line}</Text>
								</Box>
							))}
						</VStack>
						: <Box minH={'5'}><Text fontSize={'sm'} color={{ base: 'neutral.500', _dark: 'neutral.400' }}>{Res.Web.SHOW_CUSTOMER_NOT_DATA_LBL()}</Text></Box>
					}
				</Box>
			</VStack>
		</CardPanel>);
}